import onIntersectionObserve from '@/helpers/on_intersection_observe';
import { CITY_LANDING_PAGE_IDS } from '@/pages/city_landing/page_ids';

let calculatorApp = null;

pageUnload(...CITY_LANDING_PAGE_IDS, () => {
  if (calculatorApp) {
    calculatorApp.unmount();
    calculatorApp = null;
  }
});

pageLoad(...CITY_LANDING_PAGE_IDS, () => {
  const calculatorNode = document.querySelector('#city_landing_calculator');
  if (!calculatorNode) { return; }

  onIntersectionObserve(calculatorNode, initCalculator);
});

async function initCalculator(node) {
  const { createApp, h } = await import(/* webpackChunkName: "vue" */ 'vue');
  const { default: Calculator } = await import('@/vue/city_landing/calculator');

  const $node = $(node);

  calculatorApp = createApp({
    setup: () => () => h(Calculator, {
      prices: $node.data('prices'),
      tariffPercents: $node.data('tariff_percents'),
      sizeMinSquares: $node.data('size_min_squares'),
      currencySymbol: $node.data('currency_symbol'),
      rentUrl: $node.data('rent_url')
    })
  });
  calculatorApp.mount(node);
}
